import { AloftPrice, applyRoundingAndThresholds } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectBelowGradeFullBathsAdj } from './selectBelowGradeFullBathsAdj.ts';
import { selectBelowGradeHalfBathsAdj } from './selectBelowGradeHalfBathsAdj.ts';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.ts';
import { getStringValueFromAdjustment } from './utils/getStringValueFromAdjustment.ts';

const calculateBelowGradeBathsAdj = (
  fullBathsAdj: AloftPrice = AloftPrice.zero,
  halfBathsAdj: AloftPrice = AloftPrice.zero,
) => [fullBathsAdj, halfBathsAdj].reduce((acc: AloftPrice, curr) => acc.add(curr), AloftPrice.zero);

const selectBelowGradeBathsAdj = createPriceSelector(
  [selectBelowGradeFullBathsAdj, selectBelowGradeHalfBathsAdj],
  calculateBelowGradeBathsAdj,
);

const selectAppliedBelowGradeBathsAdj = createPriceSelector(
  [selectBelowGradeBathsAdj, selectAdjustmentSettings],
  (adj, adjSettings) => applyRoundingAndThresholds(adj, 'bathBelowGrade', adjSettings),
);

export const selectAppliedBelowGradeBathsAdjDisplay = createSelector(
  [selectAppliedBelowGradeBathsAdj],
  (adj) => {
    if (!adj) return undefined;

    return {
      value: getStringValueFromAdjustment(adj),
      color: getColorFromAdjustment(adj),
    };
  },
);
